import { APIClient } from 'cx-api-client-lite';

const Transifex = new APIClient({
  fetchTranslations: {
    path: '{locale}.json',
    method: 'GET',
  },
});

export default Transifex;
